import moment from 'moment';
import React, { useState } from 'react';

  const TreeNode = ({ label, data }) => {
    const [isExpanded, setIsExpanded] = useState(false);
  
    const handleToggle = () => {
      setIsExpanded(!isExpanded);
    };
  
    if (typeof data !== 'object') {
      return (
        <div>
          <div onClick={handleToggle}>
            <b>{label.replaceAll('_', ' ')}</b>: <span>{data}</span>
          </div>
        </div>
      );
    }
  
    return (
      <div >
        <div onClick={handleToggle}>
          {isExpanded ? '-' : '+'} <b>{label.replaceAll('_', ' ')}</b>
        </div>
        {isExpanded && (
          <div style={{ marginLeft: '20px' }}>
            {Object.keys(data).map((key) => (
              <TreeNode key={key} label={key} data={data[key]} />
            ))}
          </div>
        )}
      </div>
    );
  };
  
  export const ScenarioDescription = ({data, fuelTypeInfo}) => {
    const replace_ft = (scendesc) => {
      const re = new RegExp("(?<={').*?(?='})")
      return scendesc.replace(re, (f) => {if (f in fuelTypeInfo) {return fuelTypeInfo[f].short_display_name} else {return f}}).replace("{'", "").replace("'}","")
    }
    
    if (!!!data) return <div>loading data ...</div>
    return (
        
        <div>
          <p>
            The following settings have been used for this simulation:
          </p>
          <ul>
          
          <li>
           The simulation has run from {moment(data.start_time).format('MMMM Do YYYY')} to {moment(data.end_time).format('MMMM Do YYYY')}
          </li>
          <li>
            Ships have {!data.retain_capacity && <b>not</b>} automatically been added and deleted to the fleet to keep the transport capacity as constant as possible.
          </li>
          
          {data.cdm ?
            <li>
            The ships have followed the power system selection logic: every 10 year a ship reassessed the applicability of the ships' power system
          </li>
          :
          <li>
            The ships have retained their power system throughout the simulation, unless enforced from the outside
          </li>
          }
          {data.early_adopters_increase &&
          <li>
            The early adopter increase was switched on. This means that in 2020 2% of the bunker actions is performed with the energy carrier that has the best ratio between price and CO2 emission (instead of the lowest price). This percentage is increasing to 35% in 2035 and 90% in 2050.
            </li>}
          <li>The innovation level was set to {data.innovation_level}. This influences the prices and availability of energy carriers, the capex for refits, the TRL and social acceptance of technology solutions.</li>
          {data.used_fuels &&
          <li>The energy carrier types available in the simulation where: {data.used_fuels.map(f => {if (f in fuelTypeInfo) {return fuelTypeInfo[f].short_display_name} else {return f}}).join(', ')}</li>
          }
          </ul>
          {data.pathway &&
              <>
              <span>The following pathway has been defined:</span>
              <ul>
              {data.pathway.map((scen, scenidx) => (
                <li key={`scen${scenidx}`}>{replace_ft(scen.description)}</li>
              ))}

              </ul>
              </>
          }

        
            {/* {Object.keys(data).map((key) => {return (<TreeNode key={key} label={key} data={data[key]}/>) })} */}
        </div>
        

    );
  };
  
  
















